///////   particles
  document.addEventListener("DOMContentLoaded", function() {
    var particleContainer = document.getElementById("particle-container");
    if(particleContainer){
        var lineColor = particleContainer.dataset.linecolor;
        var particleColor = particleContainer.dataset.color;
        var lines = particleContainer.dataset.lines;
        var direction = particleContainer.dataset.direction;
        var params = {
            color: particleColor,
            lineColor: lineColor,
            lines: lines,
            direction: direction
        }
        initializeParticles(params);
    }
  });

function initializeParticles(params) {
    particlesJS("particle-container", {
        particles: {
          number: { value: 100, density: { enable: true, value_area: 800 } },
          color: { value: params.color || "#000"},
          shape: { type: "circle" },
          opacity: { value: 0.5, random: true, anim: { enable: true, speed: 1, opacity_min: 0 } },
          size: { value: 5, random: true },
          move: { enable: true, speed: 2, direction: params.direction || "top", random: false, straight: false, out_mode: "out" },
          line_linked: {
            enable: params.lines || false,
            color: params.lineColor || "#000",
          },
        },
        interactivity: { detect_on: "canvas", events: { onhover: { enable: true, mode: "repulse" } } },
      });
  }


////   fade in on scroll
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('show');
        } else {
            entry.target.classList.remove('show')
        }
    })
  })

  const hiddenElements = document.querySelectorAll('.hidden')
  hiddenElements.forEach((el) => observer.observe(el));
  

////spotlight
  const spotlight = document.querySelector(".spotlight");
  if (spotlight) {
    let spotlightSize = "transparent 100px, rgba(0,0,0,0.85) 160px)";

    window.addEventListener("mousemove" , e => {
        requestAnimationFrame(() => updateSpotlight(e));
    });

    function updateSpotlight(e) {
        const xPos = e.pageX / window.innerWidth * 100;
        const yPos = e.pageY / window.innerHeight * 100;
        spotlight.style.backgroundImage = `radial-gradient(circle at ${xPos}% ${yPos}%, ${spotlightSize}`
    }

    setTimeout(() => {
        spotlight.classList.add('hide')
      }, "3000");
      setTimeout(() => {
        spotlight.remove();
      }, "5000");
  }
